import { render, staticRenderFns } from "./reviewWidget.vue?vue&type=template&id=13ce2adc&"
import script from "./reviewWidget.vue?vue&type=script&lang=js&"
export * from "./reviewWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/vasile_cyt/Documents/plentyDevTool/25996/21/reviewWidget/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ce2adc')) {
      api.createRecord('13ce2adc', component.options)
    } else {
      api.reload('13ce2adc', component.options)
    }
    module.hot.accept("./reviewWidget.vue?vue&type=template&id=13ce2adc&", function () {
      api.rerender('13ce2adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/components/reviewWidget.vue"
export default component.exports